// Import model
import { StartRoomSelectionSwitchItemRequest } from '../models/StartRoomSelectionSwitchItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartRoomSelectionSwitchItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartRoomSelectionSwitchItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartRoomSelectionSwitchItemRequest instance
   */
  static deserialize(json: string): StartRoomSelectionSwitchItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartRoomSelectionSwitchItemRequest instance
   */
  static fromObject(obj: any): StartRoomSelectionSwitchItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartRoomSelectionSwitchItemRequest');
    }


    const instance: StartRoomSelectionSwitchItemRequest = {
      currentItemId: obj['currentItemId'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      source: obj['source'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartRoomSelectionSwitchItemRequest instances
   */
  static deserializeArray(json: string): StartRoomSelectionSwitchItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartRoomSelectionSwitchItemRequest instance to a JSON string
   */
  static serialize(instance: StartRoomSelectionSwitchItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartRoomSelectionSwitchItemRequest instance to a plain object
   */
  static toObject(instance: StartRoomSelectionSwitchItemRequest): any {
    return {
      'currentItemId': instance.currentItemId,
      'itemId': instance.itemId,
      'source': instance.source,
    };
  }

  /**
   * Serializes an array of StartRoomSelectionSwitchItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartRoomSelectionSwitchItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
